import { render, staticRenderFns } from "./ApplicationDemo.vue?vue&type=template&id=200c0910&scoped=true"
import script from "./ApplicationDemo.vue?vue&type=script&lang=js"
export * from "./ApplicationDemo.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDemo.vue?vue&type=style&index=0&id=200c0910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c0910",
  null
  
)

export default component.exports